/* Hermosa Aesthetics — minimal, no dependencies. */
(function () {
  'use strict';

  // Mobile navigation
  var header = document.querySelector('[data-header]');
  var burger = document.querySelector('[data-burger]');
  if (header && burger) {
    burger.addEventListener('click', function () {
      var open = header.getAttribute('data-open') === 'true';
      header.setAttribute('data-open', String(!open));
      burger.setAttribute('aria-expanded', String(!open));
    });
  }

  // Treatment accordions — first group starts open
  document.querySelectorAll('[data-group-head]').forEach(function (head) {
    head.addEventListener('click', function () {
      var group = head.closest('[data-group]');
      var open = group.getAttribute('data-open') === 'true';
      group.setAttribute('data-open', String(!open));
      head.setAttribute('aria-expanded', String(!open));
    });
  });

  // Treatment menu rows
  document.querySelectorAll('[data-menu-toggle]').forEach(function (row) {
    row.addEventListener('click', function () {
      var item = row.closest('[data-menu-item]');
      var open = item.getAttribute('data-open') === 'true';
      item.setAttribute('data-open', String(!open));
      row.setAttribute('aria-expanded', String(!open));
    });
  });

  // Scroll reveal
  var targets = document.querySelectorAll('.reveal');
  if (!targets.length) return;

  if (!('IntersectionObserver' in window)) {
    targets.forEach(function (el) { el.classList.add('is-in'); });
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-in');
        observer.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

  targets.forEach(function (el) { observer.observe(el); });
})();

/* Shop: add to cart without leaving the page, keep the header count in sync. */
(function () {
  'use strict';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function setCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      if (count > 0) { el.removeAttribute('hidden'); } else { el.setAttribute('hidden', ''); }
    });
    document.querySelectorAll('[data-cart-link]').forEach(function (el) {
      el.setAttribute('aria-label', 'Cart, ' + count + (count === 1 ? ' item' : ' items'));
    });
  }

  document.querySelectorAll('form[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      if (!window.fetch || !window.FormData) return;
      e.preventDefault();
      var button = form.querySelector('[name="add"]');
      var status = form.querySelector('[data-add-status]');
      var label = button ? button.innerHTML : '';
      if (button) { button.disabled = true; button.innerHTML = 'Adding'; }
      if (status) { status.textContent = ''; status.removeAttribute('data-error'); }

      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      })
        .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
        .then(function (result) {
          if (!result.ok) { throw new Error(result.data.description || result.data.message || 'Sorry, that could not be added.'); }
          if (status) { status.innerHTML = 'Added to your cart. <a href="' + root + 'cart">View cart</a>'; }
          return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } })
            .then(function (res) { return res.json(); })
            .then(function (cart) { setCount(cart.item_count); });
        })
        .catch(function (err) {
          if (status) { status.textContent = err.message; status.setAttribute('data-error', 'true'); }
        })
        .then(function () {
          if (button) { button.disabled = false; button.innerHTML = label; }
        });
    });
  });

  // Collection sort dropdown
  document.querySelectorAll('[data-autosubmit]').forEach(function (select) {
    select.addEventListener('change', function () { select.form.submit(); });
  });
})();
